$(function () {

    var termsAndConditionsUrl = app.tacUrl;
    if (!termsAndConditionsUrl) {
        return;
    }

    var $form = $("form[data-f-metadata='document-request-form']");
    if (!$form.length) {
        return;
    }

    var $input = $form.find("input[value='accept-terms']");
    if (!$input.length) {
        return;
    }

    var template = $("#terms-and-conditions-template").html();

    var data = { url: termsAndConditionsUrl };
    var element = Mustache.render(template, data);

    var $label = $input.parent();
    $label.contents().last().remove();
    $label.append(element);

});